import tinycolor from 'tinycolor2';

export const colors = {
  primary: '#fbf7f5',
  logo: '#F8F8F8',
  primaryDark: 'rgba(134, 134, 134, 1)',
  primaryDarkDisabledText: 'rgba(0, 0, 0, 0.26)',
  primaryDark50: 'rgba(0, 0, 0, 0.5)',
  secondaryDark: '#332a24',
  error: '#F93822',
  white: '#ffffff',
  black: '#000000',
  grey500: '#9e9e9e',
  greyDisabled: '#C6C6C6',
  greyDisabled2: '#8B8A8D',
  grey300: '#e0e0e0',
  grey100: '#f5f5f5',
  overlay: 'rgba(51, 42, 36, 0.7)',
  white10: 'rgba(1, 1, 1, 0.1)',
  whiteAlpha10: 'rgba(255, 255, 255, 0.1)',
  white40: 'rgba(255, 255, 255, 0.4)',
  greyDisabled2Alpha10: 'rgba(139, 138, 141, 0.1)',
  borderGrey: 'rgb(118, 118, 118, 0.4)',
  arrowGrey: 'rgb(118, 118, 118)',
  borderBlack: 'rgba(0, 0, 0, 0.87)',
  loaderBg: 'rgba(51, 42, 36, 0.7)',
  scrollHover: 'rgba(51, 42, 36, 0.4)',
  buttonText: '#FCF7F5',
  text: '#000000',
  cyanDark: '#404D56',
  textHover: '#636363',
  textActive: '#000000',
  cardBackground: 'rgb(201, 201, 201)',
  backgroundOverlay: 'rgba(0, 0, 0, 0.25)',
  backgroundOverlay2: 'rgba(0, 0, 0, 0.6)',
  selectBackground: '#F7F2F0',
  selectHover: '#E7E0DE',
  flagBorder: '#e6e6e6',
  secondaryBackground: '#EEDBCD',
  transparent: 'rgba(0, 0, 0, 0)',
  pink: '#F0A0BF',
  green: '#37503D',
  greenLight: '#96BB61',
  greenMid: '#66864F',
  red: '#FF4D59',

  // New colors for bg and theme change.
  colorMain: '#1D1D23', // BLACK
  colorSecondary: '#F18AAD', // PINK

  // Glow-in-the-dark badge
  glowGreen: '#92F183',

  // Modal
  modalBackground: '#2f3235',
  modalBackgroundBlur: 'rgba(29, 29, 35, 0.80)',

  // For text on a dark surface that is COMPOSITED rather than flat — a translucent
  // modal fill over a scrimmed photo, where the effective backdrop reaches ~#2C2C30
  // rather than #1D1D23. There, `greyDisabled2` is 4.05:1 and `error` 3.72:1; these
  // are the same hues a step lighter, at 6.78:1 and 4.98:1, so swapping the artwork
  // underneath cannot break them.
  //
  // Note `errorOnDark` is not merely a special case: `error` #F93822 is only 4.49:1
  // on the theme's own #1D1D23, i.e. it fails AA site-wide (see CLAUDE.md §7). This
  // one passes. Lightening `error` itself is the real fix and is not done here.
  mutedOnDark: '#B5B5B5',
  errorOnDark: '#FF6B5C',
} as const;

export const colorMid = tinycolor
  .mix(colors.colorMain, colors.colorSecondary, 50)
  .toHexString();
